document.addEventListener('DOMContentLoaded', function () {
  gsap.registerPlugin(ScrollTrigger, SplitText, TextPlugin);

  if (document.querySelector('.slim_banner')) {
    let slimBanners = document.querySelectorAll('.slim_banner');
    slimBanners.forEach((banner, index) => {
      banner.addEventListener('mouseover', () => {
        slimBanners.forEach((item, index) => {
          item.classList.remove('hide');
        });
        banner.classList.add('hide');
      });
    });
  }
});

if (document.querySelector('.usp')) {
  const usp_title = document.querySelector('.usp h2');

  const titleText = usp_title.textContent;
  usp_title.innerHTML = titleText
    .split(' ')
    .map((word, i) => `<span class="word-${i}">${word}</span>`)
    .join(' ');

  gsap.from('.usp h2 span', {
    scrollTrigger: {
      trigger: '.usp',
      start: 'top 70%',
      end: 'bottom center',
      scrub: true,
      markers: false,
    },
    color: '#ADADAD',
    stagger: 0.1,
  });
}

if (document.querySelector('#play_captivating_video')) {
  const playButton = document.querySelector('#play_captivating_video');
  const video = document.querySelector('#captivating-video');
  const overlay = document.querySelector('.captivating-video__overlay');

  playButton.addEventListener('click', () => {
    video.currentTime = 0; // Reset video to the beginning
    video.muted = false; // Unmute the video when play is clicked
    video.loop = false; // Disable looping when play is clicked
    video.setAttribute('controls', ''); // Show controls when play is clicked
    overlay.style.display = 'none';
  });
}

// Add target="_blank" to all buttons with external links
const currentDomain = window.location.hostname;
document.querySelectorAll('a[href^="http"]').forEach((link) => {
  const linkDomain = new URL(link.href).hostname;
  if (linkDomain !== currentDomain && !link.hasAttribute('target')) {
    link.setAttribute('target', '_blank');
    link.setAttribute('rel', 'noopener noreferrer');
  }
});
